import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import HomeIcon from '@mui/icons-material/Home';
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import PlayCircleIcon from '@mui/icons-material/PlayCircle'
import React, { useState } from 'react';
import UIMemberDrawer from './UIMemberDrawer';
import { ReactComponent as WrnsLogo } from '../icons/WrnsLogo.svg'
import { ReactComponent as FeatherText } from '../icons/FeatherText.svg'
import { ReactComponent as Feather } from '../icons/noun-feather-3136951.svg'
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, SpeedDial, SpeedDialAction, SpeedDialIcon, Stack } from '@mui/material';
import { appdata, featherVersion } from '../internalModules';
import Tooltip from '@mui/material/Tooltip'
import UIMaterialDrawer from './UIMaterialDrawer';
import UIButtonLoadProject from './UIButtonLoadProject';
import UIButtonImport from './UIButtonImport';
import { appBarButtonStyle } from '../Graphics';


type Props = {
  updateApp: Function
  hasButtons: boolean
}

const speedDialActions = [
  { icon: <PlayCircleIcon />, name: 'Video: How to create a material' },
  { icon: <PlayCircleIcon />, name: 'Video: How to create a framing member' },
  { icon: <PlayCircleIcon />, name: 'Video: How to create an assembly' },
  { icon: <PlayCircleIcon />, name: 'Video: How to create a scenario' },
]

export default function UIAppBar({updateApp, hasButtons}: Props) {
  const [membersOpen, setMembersOpen] = useState(false)
  const [materialsOpen, setMaterialsOpen] = useState(false)
  const [aboutOpen, setAboutOpen] = useState(false)

  const toggleMembersOpen = (open: boolean) => (event: React.MouseEvent) => {
    setMembersOpen(open);
  }

  const toggleMaterialsOpen = (open: boolean) => (event: React.MouseEvent) => {
    setMaterialsOpen(open)
  }

  const toggleAboutOpen = (open: boolean) => (event: React.MouseEvent) => {
    setAboutOpen(open)
  }

  function handleSaveFile() {
    appdata.saveJsonFile()
  }

  function handleClickHome() {
    window.open('https://feather.wrnsstudio.com/', '_blank', 'noreferrer=true')
  }

  return (
    <Box >
      <AppBar position="fixed">
        <Grid container py={.25} justifyContent={'space-between'} flexWrap={'nowrap'} maxHeight='100px'>
          
          <Grid item xs={6} display='flex' flexDirection='row' justifyContent='flex-start' >
            <Box pt={1}>
              <Feather width={140} height={40} fillOpacity={0.5} />
            </Box>
            <Box display='flex' flexDirection='column' justifyContent='center'>
              <div>
                <FeatherText />
              </div>
              <a href="https://www.wrnsstudio.com/" target={'_blank'} rel={'noreferrer'} >
                <WrnsLogo fillOpacity={0.25}/>
              </a>
            </Box>
            <Typography sx={{p:0.5, paddingLeft:2, opacity:0.3}}>Public BETA</Typography>
          </Grid>
          
          <Grid item xs={8} >
            <Stack direction='row' justifyContent='flex-end' >
              { hasButtons ?
              <>
                <Tooltip arrow title='Save the project as JSON file'>
                  <Button  variant='outlined' color='inherit' sx={appBarButtonStyle}
                    onClick={handleSaveFile} startIcon={<FileDownloadOutlinedIcon/>}>
                      SAVE
                  </Button>
                </Tooltip>
                <UIButtonLoadProject updateApp={updateApp}
                  variant='outlined'
                  color='inherit' />
                <UIButtonImport updateApp={updateApp}/>
                <Tooltip arrow title='Add / edit framing members'>
                  <Button
                    sx={appBarButtonStyle}
                    color="inherit"
                    variant='outlined'
                    endIcon={<ChevronRightIcon />}
                    onClick={toggleMembersOpen(true)}
                  >
                    Framing
                  </Button>
                </Tooltip>
                <Tooltip arrow title='Add / edit materials'>
                  <Button 
                    sx={appBarButtonStyle}
                    color="inherit"
                    variant='outlined'
                    endIcon={<ChevronRightIcon />}
                    onClick={toggleMaterialsOpen(true)}
                  >
                    Materials
                  </Button>
                </Tooltip>
              </> : <></>}
              
              <Tooltip arrow title='About'>
                <IconButton
                  sx={{ m: 0.25, borderRadius: 0 }}
                  color="inherit"
                  onClick={toggleAboutOpen(true)}              
                >
                  <QuestionMarkIcon/>
                </IconButton>
              </Tooltip>

              { hasButtons ?
              <>
                <Tooltip arrow title='Feather Home'>
                  <IconButton
                    sx={{ m: 0.25, borderRadius: 0 }}
                    color="inherit"
                    onClick={handleClickHome}              
                  >
                    <HomeIcon/>
                  </IconButton>
                </Tooltip>
              </> : <></>}
              
            </Stack>
            
          </Grid>
          
        </Grid>
        
        
        <Dialog
          open={aboutOpen}
          onClose={toggleAboutOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          scroll='paper'
        >
          <DialogTitle id="alert-dialog-title">
            <b>About Feather</b>
          </DialogTitle>
          <DialogContent>
            <Typography alignSelf={'end'} sx={{ marginBottom: 1}}>version: {featherVersion}</Typography>
            <Typography id="alert-dialog-description">
              Feather is a carbon calculator that aims to help architects and engineers
              compare the embodied carbon impacts of early phase design decisions.
              This tool was developed at WRNS Studio by Jason Halaby and
              is currently in public beta. Special thanks to contributors Jeremy Shiman and Fermin Garcia.
              <br/><br/>
              Please send comments, questions, and feedback
              to: <a href='mailto:feather@wrnsstudio.com'>feather@wrnsstudio.com</a>                
            </Typography>
            <Divider sx={{marginY: 1}} />
            <Typography>
              Feather was coded in Typescript using React, MaterialUI, and ThreeJS.
            </Typography>
            <Divider sx={{marginY: 1}} />
            <Typography variant='h6'><b>Terms of Use</b> (updated 4/20/2025)</Typography>
            <Typography>
              <p>Feather (the “Services”, “Tool”) is a tool we built for ourselves at WRNS Studio (“we”, “us”, “our”), but we wanted to share it with others in the spirit of collaboration.</p>
              <p>By using Feather, you agree to these terms.</p>
              <p><b>User Data:</b> We do not collect any project data that you enter in Feather. There is no server-side back-end to the Service. Data entered into the tool is stored locally in your browser and is not transmitted to us, nor stored in any cloud server. We recommend saving your project data to your computer regularly while working to avoid losing data.</p>
              <p><b>Disclaimer:</b> Feather is a tool in development and is provided on an as-is basis. We disclaim all warranties in connection with the Services and your use thereof. We make no warranties or representations about the accuracy or completeness of the Services, and we will assume no liability or responsibility for any errors, mistakes, or inaccuracies of content and materials.</p>
              <p><b>Limitations of Liability:</b> In no event will we be liable to you or any third party for any damages including but not limited to lost revenue, loss of data, or other damages arising from your use of the Services.</p>
              <p><b>Modifications and Interruptions:</b> We reserve the right to change or remove the contents of the Services at any time or for any reason at our discretion without notice. We will not be liable for any modification, suspension, or discontinuation of the Services. We cannot guarantee the Services will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Services, resulting in interruptions, delays, or errors.</p>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={toggleAboutOpen(false)} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <UIMemberDrawer toggleMembersOpen={toggleMembersOpen} isOpen={membersOpen} updateApp={updateApp}/>
        <UIMaterialDrawer toggleMaterialsOpen={toggleMaterialsOpen} isOpen={materialsOpen} updateApp={updateApp}/>
        {/* <SpeedDial
          ariaLabel={'help menu'}
          sx={{ position: 'fixed', top: 80, right: 0}}
          FabProps={{size: 'small'}}
          icon={<InfoSharpIcon/>}
          direction='down'
        >
          {speedDialActions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
            />
          ))}
        </SpeedDial> */}
      </AppBar>
    </Box>
  )
}